import axios from 'axios';
import utils from '@/utils/index.js';
let navConfig = window;
const limit = 20;
const language = utils.loadLanguage();
const cty = utils.loadCountries();
let session = 'init';
let store = {
    navConfig
};

store.getChannelList = (params) => new Promise((resolve, reject) => {
    let offset = (params.page - 1) * limit;
    axios({
         url: `https://innews.infohubnews.app/ad/mixnews?lang=${language}&cty=${cty}&cc=inop&session=${session}&c=${params.category}&limit=20&offset=${offset}`
    }).then((res) => {
        if(res.status === 200) {
            let data = res.data;
            session = data.session;
            if(data.ads.length > 0) {
                resolve(data.ads);
                INFOHUBTACKER({event: 'request',type: 'mixnews'});
            } else {
                reject('no data');
            }
        }
    });
});

export default store;


// WEBPACK FOOTER //
// ./src/utils/store.js